<script>
import MethodButtonBase from './MethodButtonBase';
import IconAtHandy from '../../assets/svg/at-handy-sign.svg';
export default {
  name: 'AtHandyButton',
  components: {
    MethodButtonBase,
    IconAtHandy,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconAtHandy :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      Handy-Signatur
    </template>
  </MethodButtonBase>
</template>


<style lang="scss" module>
.icon {
  display: block;
  width: 20px;
  height: auto;
  margin-right: 8px;
  fill: #ce161e;
}
</style>
